import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import PatientBackground from '../components/PatientBackground.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeclineConfirmView',
  setup(__props) {

const router = useRouter()

onMounted(() => {
  setTimeout(() => router.push('/'), 4000)
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height vc-tv-canvas-bg vc-incoming-root"
  }, {
    default: _withCtx(() => [
      _createVNode(PatientBackground),
      _createVNode(_component_v_sheet, {
        class: "vc-incoming-panel vc-confirm-rail d-flex flex-column bg-white",
        elevation: "24",
        height: "100%",
        rounded: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "vc-confirm-icon vc-confirm-icon--muted" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-check-circle", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "vc-confirm-body" }, "No problem. We will notify your care team.", -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})